<template>
    <!-- 根据tableData的值去显示隐藏列表 -->
    <div style="height:100%">
        <div class="Main">
            <div class="topMain">
                <div slot="header" class="clearfix">
                    <span>用户管理</span>
                    <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
                    </el-button>
                    <div style="float: right;" v-if="multipleSelection.length != 0">
                        <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
                            个</span>
                        <el-dropdown trigger="click" @command="operationBtn">
                            <span class="el-dropdown-link">
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="{ type: 'del', para: multipleSelection }">删除
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
            <div class="coreMain">
                <div>
                    <el-input class="input-with-select" placeholder="搜索用户" v-model="search" @keyup.enter.native="searchBtn">
                    </el-input>
                    <el-button @click="searchBtn" slot="append" type="primary" icon="el-icon-search"></el-button>
                    <el-button class="clearSearch" type="text" @click="reset">清除搜索条件
                    </el-button>
                </div>
                <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="account" label="用户名">
                    </el-table-column>
                    <el-table-column prop="roleName" label="所属角色"></el-table-column>
                    <el-table-column prop="nickName" label="昵称"></el-table-column>
                    <el-table-column prop="sex" label="性别">
                        <template slot-scope="scope">
                            <span>{{
                scope.row.sex == 1 ? "男" : scope.row.sex == 2 ? "女" : "其他"
                }}</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column
            prop="avatar"
            label="头像"
          ></el-table-column>-->
                    <el-table-column prop="phone" label="手机号码"></el-table-column>
                    <el-table-column prop="email" label="邮箱"></el-table-column>
                    <el-table-column prop="appKey" label="appKey"></el-table-column>
                    <el-table-column prop="appSecret" label="appSecret"></el-table-column>
                    <el-table-column prop="accountStatus" label="账号状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.accountStatus == 0">
                                <i class="redDot"></i>禁用</span>
                            <span v-else-if="scope.row.accountStatus == 1">
                                <i class="greenDot"></i>正常</span>
                            <span v-else>---</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastLoginDate" label="最后登录时间">
                        <template slot-scope="scope">
                            <span>{{ changeDate(scope.row.lastLoginDate) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="">
                        <template slot-scope="scope">
                            <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                                <span class="el-dropdown-link">
                                    <i class="el-icon-more"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="{ type: 'edit', id: scope.row.id }">编辑
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="{ type: 'disable', id: scope.row.id,isDisable:scope.row.accountStatus === 1}">
                                        {{scope.row.accountStatus === 1 ? '禁用':'启用' }}
                                    </el-dropdown-item>
                                    <el-dropdown-item v-has="'userManagement:resetPassword'" :command="{ type: 'resetPassword', id: scope.row.id }">重置密码
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100,200,500,1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 创建用户角色 -->
        <el-dialog title="创建用户" :show-close="false" :visible.sync="dialogFormVisible">
            <el-form :model="addForm" status-icon ref="addForm" :rules="addFormRules" :label-width="formLabelWidth">
                <el-form-item label="用户头像：" prop="avatar">
                    <el-upload class="avatar-uploader" :action='upload' :data="tokenData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept=".jpg, .png, .jpeg">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="用户名：" prop="account">
                    <el-input style="width:70%" v-model="addForm.account" autocomplete="off" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="昵称：" prop="nickName">
                    <el-input style="width:70%" v-model="addForm.nickName" autocomplete="off" maxlength="100"></el-input>
                </el-form-item>

                <el-form-item label="性别：" prop="sex">
                    <el-radio-group v-model="addForm.sex">
                        <el-radio label="1">男</el-radio>
                        <el-radio label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="密码：" prop="userPwd">
                    <el-input style="width:50%" type="password" v-model="addForm.userPwd" auto-complete="off" placeholder="建议包含数字，字母，符号至少2种的6位以上组合" maxlength="50">
                    </el-input>
                    <el-rate style="width:32%;display:inline-block" v-model="passwordLevel" :texts="texts" show-text disabled :colors="['#F56C6C', '#E6A23C',  '#67C23A']">
                    </el-rate>
                </el-form-item>
                <el-form-item label="确认密码：" prop="checkPass">
                    <el-input style="width:70%" type="password" v-model="addForm.checkPass" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色：" prop="roleId">
                    <el-select style="width:70%" v-model="addForm.roleId" filterable clearable placeholder="请选择角色">
                        <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机：" prop="phone">
                    <el-input style="width:70%" v-model='addForm.phone' auto-complete="off" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="email">
                    <el-input style="width:70%" v-model='addForm.email' auto-complete="off" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="appKey：" prop="appKey">
                    <el-input style="width:70%" v-model='addForm.appKey' auto-complete="off" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="appSecret：" prop="appSecret">
                    <el-input id="appSecret" style="width:70%" v-model='addForm.appSecret' auto-complete="off" maxlength="32" readonly>
                    </el-input>
                    <el-button @click="copyAppSecret('add')">复制</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addCancel">取 消</el-button>
                <el-button type="primary" :disabled="passwordLevel<3" @click="setUp('addForm')">确 定
                </el-button>
            </div>
        </el-dialog>
        <!-- 编辑用户 -->
        <el-dialog title="编辑用户" :show-close="false" :visible.sync="editdialogFormVisible">
            <el-form :model="editForm" status-icon ref="editForm" :rules="addFormRules" :label-width="formLabelWidth">
                <el-form-item label="用户头像：" prop="avatar">
                    <el-upload class="avatar-uploader" :action='upload' :data="tokenData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept=".jpg, .png, .jpeg">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="用户名：" prop="account">
                    <el-input style="width:70%" v-model="editForm.account" autocomplete="off" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="昵称：" prop="nickName">
                    <el-input style="width:70%" v-model="editForm.nickName" autocomplete="off" maxlength="100"></el-input>
                </el-form-item>

                <el-form-item label="性别：" prop="sex">

                    <el-radio-group v-model="editForm.sex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>

                </el-form-item>

                <el-form-item label="角色：" prop="roleId">
                    <el-select style="width:70%" v-model="editForm.roleId" filterable clearable placeholder="请选择角色">
                        <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机：" prop="phone">
                    <el-input style="width:70%" v-model='editForm.phone' auto-complete="off" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="email">
                    <el-input style="width:70%" v-model='editForm.email' auto-complete="off" maxlength="100"></el-input>
                </el-form-item>

                <el-form-item label="appKey：" prop="appKey">
                    <el-input style="width:70%" v-model='editForm.appKey' auto-complete="off" maxlength="20" readonly></el-input>
                </el-form-item>
                <el-form-item label="appSecret：" prop="appSecret">
                    <el-input style="width:70%" id="appSecret1" v-model='editForm.appSecret' auto-complete="off" maxlength="32" readonly>
                    </el-input>
                    <el-button @click="copyAppSecret('edit')">复制</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editdialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editSetUp('editForm')">确 定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="重置密码" :show-close="false" :visible.sync="passwordFormVisible" :close-on-click-modal="false">
            <el-form :model="passwordForm" status-icon ref="passwordForm" :rules="passwordFormRules">
                <el-form-item label="新密码" prop="userPwd">
                    <el-input type="text" v-model="passwordForm.userPwd" style="width:60%" placeholder="建议包含数字，字母，符号至少2种的6位以上组合">
                    </el-input>
                    <el-rate style="width:32%;display:inline-block" v-model="resetPasswordLevel" :texts="texts" show-text disabled :colors="['#F56C6C', '#E6A23C',  '#67C23A']">
                    </el-rate>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="passwordFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="resetPasswordSubmit" :disabled="resetPasswordLevel <= 2 ">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import API from "../../api/api";
import dayjs from "dayjs"
import Base64 from 'js-base64'
export default {
    data() {
        //密码验证
        var validatePass = (rule, value, callback) => {
            let _this = this
            if (value == '') {
                callback(new Error('请输入密码（建议包含数字，字母，符号至少2种的6位以上组合）'));
            } else {
                if (_this.addForm.checkPass != '') {
                    _this.$refs.addForm.validateField('checkPass');
                }
                callback();
            }
        };
        // 重置密码
        var resetValidatePass = (rule, value, callback) => {
            let _this = this
            if (value == '') {
                callback(new Error('请输入密码（建议包含数字，字母，符号至少2种的6位以上组合）'));
            } else {
                callback();
            }

        };
        //确认密码
        var validatePass2 = (rule, value, callback) => {
            let _this = this
            if (value == '') {
                callback(new Error('请再次输入密码'));
            } else if (value != _this.addForm.userPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            total: 0,
            pageSize: 10,
            currentPage: 1,
            loading: false, //加载条
            search: "", //搜索
            tableData: [],
            multipleSelection: [],
            formLabelWidth: "180px",
            //新增用户
            addForm: {
                account: '',
                userPwd: '',
                roleId: '',
                nickName: '',
                sex: '1',
                phone: '',
                avatar: '',
                email: '',
                appKey: '',
                appSecret: '',
                checkPass: ''
            },
            passwordLevel: 1, //密码强度
            texts: ['极弱', '普通', '中等', '较强', '很强'],
            //编辑
            editForm: {},
            dialogFormVisible: false,
            editdialogFormVisible: false,
            roleList: [], //角色列表
            imageUrl: '',
            upload: API.uploadFile(), //上传地址
            addFormRules: {
                account: [{
                    required: true,
                    message: '请输入用户名',
                    trigger: 'blur'
                }],
                nickName: [{
                    required: true,
                    message: '请输入昵称',
                    trigger: 'blur'
                }],
                userPwd: [{
                    required: true,
                    validator: validatePass,
                    trigger: 'blur'
                }],
                checkPass: [{
                    required: true,
                    validator: validatePass2,
                    trigger: 'blur'
                }],
                roleId: [{
                    required: true,
                    message: '请选择角色',
                    trigger: 'change'
                }],
                appKey: [{
                    required: true,
                    message: '请输入appKey',
                    trigger: 'blur'
                }],
                appSecret: [{
                    required: true,
                    message: '请输入appSecret',
                    trigger: 'blur'
                }],
                phone: [{
                    pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                    trigger: 'blur',
                    message: '不合法的手机号码'
                }],
                email: [{
                    pattern: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                    trigger: 'blur',
                    message: '不合法的邮箱地址'
                }],
            },
            editFormRules: {
                account: [{
                    required: true,
                    message: '请输入用户名',
                    trigger: 'blur'
                }],
                nickName: [{
                    required: true,
                    message: '请输入昵称',
                    trigger: 'blur'
                }],
                roleId: [{
                    required: true,
                    message: '请选择角色',
                    trigger: 'change'
                }]
            },
            passwordFormVisible: false,
            passwordFormRules: {
                userPwd: [{
                    required: true,
                    validator: resetValidatePass,
                    trigger: 'blur'
                }],
            },
            passwordForm: {
                id: null,
                userPwd: '',
            },
            resetPasswordLevel: 1, //密码强度
            texts: ['极弱', '普通', '中等', '较强', '很强'],
        };
    },
    computed: {
        tokenData: function () {
            return {
                access_token: this.$cookies.get('access_token')
            }
        }
    },
    watch: {
        'addForm.userPwd': function (val) {
            this.passwordLevel = this.checkPassword(val)
        },
        'passwordForm.userPwd': function (val) {
            this.resetPasswordLevel = this.checkPassword(val)
        }
    },
    created() { },
    methods: {

        copyAppSecret(type) {
            let text = document.querySelector('#appSecret');
            if (type === 'edit') {
                text = document.querySelector('#appSecret1');
            }
            text.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$message.info('复制成功');
        },


        randomWord(randomFlag, min, max) {
            let str = "",
                range = min,
                arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
                    'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E',
                    'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
                ];

            // 随机产生
            if (randomFlag) {
                range = Math.round(Math.random() * (max - min)) + min;
            }
            for (let i = 0; i < range; i++) {
                let pos = Math.round(Math.random() * (arr.length - 1));
                str += arr[pos];
            }
            return str;
        },

        //初始化时间
        changeDate(time) {
            if (time != null) {
                return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
            }
            return "";
        },
        //获取列表数据
        getPage() {
            let para = {
                pageSize: this.pageSize,
                currentPage: this.currentPage,
                account: this.search
            }
            this.loading = true; /*显示加载条*/
            API.userPage(para).then(res => {
                if (res.code == 1) {
                    this.tableData = res.data.resultPage
                    this.total = res.data.total;
                } else {
                    this.$message.error(res.msg);
                }
                this.loading = false; /*显示加载条*/
            })
        },
        getRoleList() {
            let para = {
                pageSize: 99999,
                currentPage: 1,
            }
            API.rolePage(para).then(res => {
                if (res.code == 1) {
                    this.roleList = res.data.resultPage
                }
            })
        },

        //搜索功能
        searchBtn() {
            this.currentPage = 1;
            this.status = "", //下拉选项为空
                this.getPage();
        },
        //清除搜索条件
        reset() {
            this.currentPage = 1;
            this.search = "";
            this.getPage();
        },

        addCancel() {
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
        },

        //选择的数组
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //批量操作-删除
        operationBtn(val) {
            if (val.type == "del") {
                let arr = [];
                val.para.forEach(element => {
                    arr.push(element.id);
                });
                let str = arr.join(",");
                this.delBtn(str);
            }
        },
        //单独删除功能
        command(val) {
            if (val.type == "del") {
                let str = val.id;
                this.delBtn(str);
            } else if (val.type == "edit") {
                this.editdialogFormVisible = true;
                API.userView(val.id).then(res => {
                    if (res.code == 1) {
                        this.editForm = res.data
                        this.getImage(res.data.avatar)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            } else if (val.type == "disable") {
                this.disableUser(val);
            } else if (val.type == 'resetPassword') {
                this.passwordForm.userPwd = ''
                this.passwordFormVisible = true
                this.passwordForm.id = val.id
            }
        },

        getImage(attachId) {
            let token = this.$cookies.get('access_token');
            let url = attachId + "&access_token=" + (token ? token : '');
            this.imageUrl = API.download(url)
        },

        disableUser(commandObj) {
            let para = {
                id: commandObj.id,
                enable: commandObj.isDisable ? 0 : 1
            }
            API.disableSysUser(para).then(res => {
                if (res.code === 1) {
                    this.getPage()
                } else {
                    this.$message.error(res.msg);
                }
            })
        },


        //删除功能 单独批量公用
        delBtn(delID) {
            let para = {
                ids: delID
            };
            this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    API.delSysUser(para).then(res => {
                        if (res.code == 1) {
                            this.$message.success("删除成功");
                            this.getPage();
                        } else {
                            this.$message.error("删除失败");
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        //跳转到详情页
        detailBtn(id) {
            //  直接调用$router.push 实现携带参数的跳转
            // this.$router.push({
            //   path: "/device/moduleDetail",
            //   query: {
            //     id: id
            //   }
            // });
        },

        genAppKey() {
            let randomWord = this.randomWord(false, 20);
            this.addForm.appKey = randomWord
            let r1 = this.randomWord(false, 32);
            this.addForm.appSecret = r1
        },

        //弹出创建页
        addBtn() {
            this.dialogFormVisible = true
            this.genAppKey()
        },
        //上传头像
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                this.imageUrl = URL.createObjectURL(file.raw);
                this.addForm.avatar = res.data.id
                this.editForm.avatar = res.data.id
            } else {
                this.$message.error(res.msg)
            }
        },
        //头像校验
        beforeAvatarUpload(file) {
            const isJPG = file.type == 'image/jpeg' || file.type == "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('只能上传JPG/PNG格式的头像');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        //创建用户按钮
        setUp(formName) {
            let _this = this;
            let _API = API;
            this.$refs[formName].validate((valid) => {
                if (valid) {



                    _API.addSysUser(_this.addForm).then(res => {
                        if (res.code == 1) {
                            _this.$message({
                                message: "创建用户成功",
                                type: "success"
                            });
                            this.dialogFormVisible = false;
                            this.getPage();
                        } else {
                            _this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        editSetUp(formName) {
            let _this = this;
            let _API = API;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    _API.editSysUser(_this.editForm).then(res => {
                        if (res.code == 1) {
                            _this.$message({
                                message: "编辑用户成功",
                                type: "success"
                            });
                            this.editdialogFormVisible = false;
                            this.getPage();
                        } else {
                            _this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getPage();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getPage();
        },
        // 重置密码
        resetPasswordSubmit() {
            this.$refs['passwordForm'].validate((valid) => {
                if (!valid) return
                API.superChangePwd(this.passwordForm).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message: "重置密码成功",
                            type: "success"
                        });
                        this.passwordFormVisible = false;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            });
        },
    },
    mounted() {
        this.getPage();
        this.getRoleList();
    }
};

</script>


// WEBPACK FOOTER //
// src/views/platform/userManagement.vue